"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SemVersion$ = exports.SemVersion$outboundSchema = exports.SemVersion$inboundSchema = void 0;
exports.semVersionToJSON = semVersionToJSON;
exports.semVersionFromJSON = semVersionFromJSON;
const z = __importStar(require("zod"));
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.SemVersion$inboundSchema = z.object({
    build: z.nullable(z.string()),
    major: z.number().int(),
    minor: z.number().int(),
    patch: z.number().int(),
    prerelease: z.nullable(z.string()),
});
/** @internal */
exports.SemVersion$outboundSchema = z.object({
    build: z.nullable(z.string()),
    major: z.number().int(),
    minor: z.number().int(),
    patch: z.number().int(),
    prerelease: z.nullable(z.string()),
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var SemVersion$;
(function (SemVersion$) {
    /** @deprecated use `SemVersion$inboundSchema` instead. */
    SemVersion$.inboundSchema = exports.SemVersion$inboundSchema;
    /** @deprecated use `SemVersion$outboundSchema` instead. */
    SemVersion$.outboundSchema = exports.SemVersion$outboundSchema;
})(SemVersion$ || (exports.SemVersion$ = SemVersion$ = {}));
function semVersionToJSON(semVersion) {
    return JSON.stringify(exports.SemVersion$outboundSchema.parse(semVersion));
}
function semVersionFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.SemVersion$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'SemVersion' from JSON`);
}
//# sourceMappingURL=semversion.js.map